// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__W3+Kg","ant-page-header-heading-title":"styles_ant-page-header-heading-title__lbgXG","table":"styles_table__I8ez1"};